<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)"
    title="{{(editor.isDesigning() ? 'move':'')|translate}}" for="gridField-{{field.Id}}"
    ng-bind-html="labelText"></label>
<span class="field-description" ng-bind-html="descriptionText"></span>
<div ng-if="showGrid()" id="managed-grid-{{field.Id}}"></div>
<div ng-if="showEditorGrid()" class="grid-field">
    <table class="gridfield-editor-dummy">
        <tbody>
            <tr><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td></tr>
            <tr><td></td><td></td><td></td><td></td></tr>
        </tbody>
    </table>
</div>
<div ng-if="tool"><i class="fa fa-table"></i></div>